import { createApi } from '@/api/modules/utils'

const baseUrl = '/knowledge/file'
const api = createApi(baseUrl)

// 用户相关API
export const knowledgeFileApi = {
  list: api('list', 'get'),
  insert: api('insert', 'post'),
  update: api('update', 'post'),
  delete: api('delete', 'get'),
  select: api('select', 'get'),
}